import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import * as firebase from 'firebase';
import { CartaServices } from '../../services';

@Component({
  selector: 'page-carta-view-simulator',
  templateUrl: 'carta-view-simulator.html',
})
export class CartaViewSimulatorPage {

  dishes = [];
  products = [];
  simulator_elements = [];
  get_dishes: boolean = false;
  get_products: boolean = false;

  total_price = 0;
  total_foodcost = 0;
  total_benefit = 0;
  total_benefit_progress_bar = 0;

  carta_name;

  public firestore;

  constructor(
    public navParams: NavParams,
    public globals: Globals,
    public cartaServices: CartaServices,
  ) {
    this.firestore = firebase.firestore();
    this.carta_name = this.navParams.get('carta_title');
    this.getDishes();
    this.getProducts();
  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  async getDishes() {
    //recuperamos todos los platos
    await this.firestore.collection('dish').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        _doc.UID = doc.id;
        this.dishes.push(_doc);

      });
      this.get_dishes = true;

    });
  }

  async getProducts() {
    //recuperamos todos los productos
    await this.firestore.collection('products').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        _doc.UID = doc.id;
        this.products.push(_doc);
      });
      this.get_products = true;
    });
  }

  addElement(element) {
    var _push = {
      "name": this.getNameLang(element, this.cartaServices.carta_lang),//nom del producto/plato/menu
      "uid_element": element.uid,//uid el producto/plato/menu
      "price": element.price,//precio 
      "foodcost": this.getFoodcost(element),//foodcost
    };
    this.simulator_elements.push(_push);
    this.updateTotals();
  }

  deleteElement(element) {
    var index = this.simulator_elements.findIndex(value => value.uid_element == element.uid_element);
    if (index > -1) {
      this.simulator_elements.splice(index, 1);
    }
    this.updateTotals();
  }

  getFoodcost(element) {
    var total = 0;
    //comprobamos que el elemento se un dish o un product
    if (element.type == "dish") { //dish
      var index_dish = this.dishes.findIndex(value => value.UID == element.uid);
      if (index_dish >= 0) {
        if (this.dishes[index_dish].foodcost_parts && this.dishes[index_dish].foodcost_static) {
          total = (this.dishes[index_dish].foodcost_static / parseFloat(this.dishes[index_dish].foodcost_parts));
        } else {
          total = 0;
        }
      }
    } else if (element.type == "product") { //product
      //buscamos el producto dentro del listado
      var index_product = this.products.findIndex(value => value.UID == element.uid);
      if (index_product != -1) {
        if (this.products[index_product].sub_recipe) { //comprovamos si es tiene escandallo
          //
          if (this.products[index_product].foodcost_parts && this.products[index_product].price_static) {
            total = (this.products[index_product].price_static / parseFloat(this.products[index_product].foodcost_parts));
          } else {
            total = 0;
          }
        } else {
          total = this.products[index_product].price_static;
        }
      }
    }
    return total;
  }

  profitFoodCost(price, foodcost) {
    //Quitamos el tax del precio
    return 100 - this.globals.regla3(price, foodcost);
  }

  async updateTotals() {
    await this.getTotalPvp();
    await this.getTotalFoodcost();
    this.getTotalMargin();
  }

  async getTotalPvp() {
    var total = 0;
    for (let element of this.simulator_elements) {
      total += element.price;
    }
    this.total_price = this.globals.createSubTotal(total, this.globals.RESTAURANT_TAX);
  }

  async getTotalFoodcost() {
    var total = 0;
    for (let element of this.simulator_elements) {
      total += element.foodcost;
    }
    this.total_foodcost = total;
  }

  getTotalMargin() {
    this.total_benefit = this.total_price - this.total_foodcost;
    var _total_benefit_progress_bar = this.globals.round2decimal(this.profitFoodCost(this.total_price, this.total_foodcost));
    //mirar si es nan para ponerlo a 0 en caso si nan
    if (Number.isNaN(_total_benefit_progress_bar)) {
      _total_benefit_progress_bar = 0;
    }
    //truncamos para que no decimal el porcentaje
    this.total_benefit_progress_bar = Math.trunc(_total_benefit_progress_bar);
  }

  getNameLang(obj, lang) {
    switch (lang) {
      case "es":
        return obj.name_es
      case "ca":
        return obj.name_ca
      case "en":
        return obj.name_en
      case "it":
        return obj.name_it
      case "de":
        return obj.name_de
      case "fr":
        return obj.name_fr
      default:
        return obj.name_es
    }
  }

  getColor(percentatge) {
    if (percentatge <= 33) {
      return "red";
    } else if (percentatge > 33 && percentatge <= 66) {
      return "orange";
    } else {
      return "green";
    }
  }

  getColorBackground(percentatge) {
    if (percentatge <= 33) {
      return "#ec632a";
    } else if (percentatge > 33 && percentatge <= 66) {
      return "#ffa500";
    } else {
      return "#5bb189";
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-view-simulator/carta-view-simulator.ts